'use client';
import { useEffect } from 'react';

/**
 * When the URL hash matches the given target ID, performs a deferred smooth
 * scroll to correct the position after the component has mounted and rendered.
 *
 * @param targetId - The element ID to scroll to (without '#')
 * @param delay - Delay in ms before scrolling (default: 500)
 */
const DEFAULT_DELAY_MS = 500;

// -----------------------------------------------------------------------------
export const useHashScroll = (
  targetId: string,
  delay = DEFAULT_DELAY_MS,
): void => {
  useEffect(() => {
    if (window.location.hash !== `#${targetId}`) return;

    const timeoutId = setTimeout(() => {
      document.getElementById(targetId)
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [targetId, delay]);
};
